<div>  
    <section>  
        <gen-dynamic-form     
          [formConfig]="formConfig"
          [formVertical]="true"
          [editMode]="isEditMode"
          class="tags-dynamic-form"
          [formData]="tagsData | async"
          (formChange)="onUpdateData($event)"
          [disabled]="!isEditMode"
          [listenToDataChange]="true">
        </gen-dynamic-form>
    </section>
</div>

<section class="actions-container"
         *ngIf="isEditMode && controls">
  <gen-button
          *ngFor="let control of controls"
          [text]="control.name"
          [type]="control.btnType? control.btnType : 'primary'"
          [iconClass]="control.iconClass"
          (click)="buttonClick(control.type)">
  </gen-button>
</section>

<section class="actions-container-edit" *ngIf="enableEditButton && !isEditMode">       
  <gen-button
          [text]="'Edit'"
          [type]="'primary'"
          [disabled]="disableEditButton"  
          (click)="buttonClick('edit')">
  </gen-button>
</section>
